export default __webpack_public_path__ + "static/media/ic_glp_40.8a07bd26.svg";